import React from 'react';
import { Lock } from 'lucide-react';
import type { MapPoint } from '../../data/itinerary-mock';

interface RouteThumbProps {
  path: MapPoint[];
  color: string;
  locked?: boolean;
}

/** Tiny route sketch used on itinerary cards. */
const RouteThumb: React.FC<RouteThumbProps> = ({ path, color, locked = false }) => {
  const route = path
    .map((point, index) => `${index === 0 ? 'M' : 'L'} ${point.x.toFixed(1)} ${point.y.toFixed(1)}`)
    .join(' ');
  const start = path[0];
  const end = path[path.length - 1];

  return (
    <span className={`it-thumbwrap${locked ? ' is-locked' : ''}`}>
      <svg className="it-thumb" viewBox="0 0 100 70" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
        <rect className="it-thumb__bg" width="100" height="70" />
        <path className="it-thumb__road" d="M0 18H100M0 40H100M0 58H100M24 0V70M58 0V70M82 0V70" />
        <ellipse className="it-thumb__park" cx="74" cy="50" rx="12" ry="8" />
        {route ? <path className="it-thumb__route" d={route} stroke={color} /> : null}
        {start ? (
          <g>
            <circle cx={start.x} cy={start.y} r="6.2" fill="var(--ml-info, #2563eb)" />
            <text x={start.x} y={start.y + 2.2} textAnchor="middle" className="it-thumb__num">1</text>
          </g>
        ) : null}
        {end && path.length > 1 ? (
          <g>
            <circle cx={end.x} cy={end.y} r="6.2" fill="var(--ml-info, #2563eb)" />
            <text x={end.x} y={end.y + 2.2} textAnchor="middle" className="it-thumb__num">2</text>
          </g>
        ) : null}
      </svg>
      {locked ? (
        <span className="it-thumb__lock">
          <Lock size={16} aria-hidden="true" />
        </span>
      ) : null}
    </span>
  );
};

export default RouteThumb;
